import React from "react";
import classnames from "classnames";
import {
    PlusIcon,
    StyledIconButton,
    VerticalDotsIcon,
} from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";

import { store as useStore } from "@components/VerticalLayout/store";
import { store, setIsPlusIconClicked } from "./store";

import ErrorToast from "@components/Common/ErrorTost";
import { CustomMainColorButtonWithIcon } from "@components/Common/CustomMainColorButtonWithIcon";
import { useRowHelpers } from "./helpers";

export function CustomSideFilter({
    selectedRows,
    setDataIsUpdated,
    setLocalFilterActive,
    isAddProject,
    setIsAddProject,
    setIsProjectArchived,
    setIsInInitializationModalOpened,
    setIsHistoryModalOpened,
    isHistoryModalOpened,
    setIsConfirmationModalArchived,
    setIsConfirmationModalActived,
    setIsModalDissociateOpened,
    isProjectArchived,
    setTypeDisplay,
    setSelectedRows,
}: {
    selectedRows: Record<string, any>;
    setDataIsUpdated: (value: boolean | number) => void;
    setLocalFilterActive: (value: boolean) => void;
    isAddProject: boolean;
    setIsAddProject: (value: boolean) => void;
    setIsProjectArchived: (value: boolean) => void;
    setIsInInitializationModalOpened: (value: boolean) => void;
    setIsHistoryModalOpened: (value: boolean) => void;
    isHistoryModalOpened: boolean;
    setIsConfirmationModalArchived: (value: boolean) => void;
    setIsConfirmationModalActived: (value: boolean) => void;
    setIsModalDissociateOpened: (value: boolean) => void;
    isProjectArchived: boolean;
    setTypeDisplay: (value: string) => void;
    setSelectedRows: (value: any) => void;
}) {
    const { t } = useTranslation();
    const { oneShop } = useSnapshot(useStore);
    const { numberArchived, numberActive, isEdited, modify } = useSnapshot(
        store
    );
    const { isExistDevice, isDisable } = useRowHelpers(selectedRows);
    const IsExistPeripheral = isExistDevice();
    const existShop = isDisable();
    return (
        <div className="d-flex justify-content-start align-items-center ml-2">
            {modify === true && (
                <>
                    {isAddProject !== true ? (
                        <span
                            onClick={() => {
                                if (oneShop) return;
                                setSelectedRows({});
                                setIsAddProject(!isAddProject);
                                setLocalFilterActive(false);
                            }}
                            className={
                                isProjectArchived || oneShop
                                    ? "w-100 ml-2 not-allowed-icon__clz cmn_btn_openForm"
                                    : "w-100 ml-2 cmn_btn_openForm"
                            }
                        >
                            <CustomMainColorButtonWithIcon
                                icon="PlusIcon"
                                iconPosition="left"
                                rounded
                                variant="primary"
                            >
                                {t("Add a project")}
                            </CustomMainColorButtonWithIcon>
                        </span>
                    ) : (
                        <StyledIconButton
                            icon="PlusIcon"
                            className="bg-dark"
                            rounded
                            disabled={selectedRows.length === 0 ? false : true}
                            onClick={() => {
                                if (isEdited === true)
                                    setIsInInitializationModalOpened(true);
                                else {
                                    setIsPlusIconClicked(true);
                                }
                            }}
                        >
                            <PlusIcon height={20} width={20} fill="white" />
                        </StyledIconButton>
                    )}
                </>
            )}
            <VerticalDotsIcon
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                style={{ cursor: "pointer" }}
                height={25}
                width={25}
                fill="black"
                className="cmn_drp_FRmenu"
            />
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <div
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "dropdown-item pl-1 cmn_btn_FRlistActivated"
                    )}
                    onClick={() => {
                        setIsProjectArchived(false);
                        setTypeDisplay("notArchived");
                        setDataIsUpdated(true);
                    }}
                >
                    {t("Project activated")} ({numberActive})
                </div>
                {!oneShop ? (
                    <div
                        style={{ cursor: "pointer" }}
                        className={classnames(
                            "dropdown-item pl-1 cmn_btn_FRlistArchived"
                        )}
                        onClick={() => {
                            setIsProjectArchived(true);
                            setTypeDisplay("Archived");
                            setIsAddProject(false);
                            setDataIsUpdated(true);
                        }}
                    >
                        {t("Archived project")} ({numberArchived})
                    </div>
                ) : null}

                {modify === true && (
                    <>
                        <div
                            style={{ cursor: "pointer" }}
                            className={`${classnames(
                                "dropdown-item pl-1",
                                {
                                    "not-allowed-icon__clz":
                                        selectedRows.length <= 1 || existShop,
                                },
                                isProjectArchived
                                    ? "cmn_btn_FRunarchive"
                                    : oneShop
                                    ? "cmn_btn_delete"
                                    : "cmn_btn_FRarchived"
                            )}`}
                            onClick={() => {
                                if (oneShop) {
                                    setIsModalDissociateOpened(true);
                                } else {
                                    if (isProjectArchived) {
                                        setIsConfirmationModalActived(true);
                                    } else {
                                        if (IsExistPeripheral) {
                                            ErrorToast(
                                                t(
                                                    "Please note that you cannot archive a project associated with the store(s)."
                                                )
                                            );
                                        } else {
                                            setIsConfirmationModalArchived(
                                                true
                                            );
                                        }
                                    }
                                }
                            }}
                        >
                            {!isProjectArchived
                                ? oneShop
                                    ? `${t("Delete")}`
                                    : `${t("Archive")}`
                                : `${t("Enable")}`}
                        </div>
                    </>
                )}
                {!oneShop && modify === true && (
                    <>
                        <div
                            style={{ cursor: "pointer" }}
                            className={`${classnames(
                                "dropdown-item pl-1",
                                {
                                    "not-allowed-icon__clz":
                                        selectedRows.length <= 1 ||
                                        !existShop ||
                                        !IsExistPeripheral,
                                },
                                isProjectArchived
                                    ? "cmn_btn_FRunarchive"
                                    : oneShop
                                    ? "cmn_btn_delete"
                                    : "cmn_btn_FRarchived"
                            )}`}
                            onClick={() => {
                                setIsModalDissociateOpened(true);
                            }}
                        >
                            {t("Dissociate")}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
